import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';
import BackToHomeButton from '../../components/BackToHomeButton';

interface AdminHeaderProps {
  title: string;
  icon: LucideIcon;
}

export default function AdminHeader({ title, icon: Icon }: AdminHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-8">
      <div className="flex items-center gap-3">
        <Icon className="h-8 w-8 text-brand-teal" />
        <h1 className="text-3xl font-bold text-brand-teal">{title}</h1>
      </div>
      <BackToHomeButton />
    </div>
  );
}